import './assets/NcRichText-BKoK9ulg.css';
import NcActionButton from "./Components/NcActionButton.mjs";
import { N as NcActionButtonGroup } from "./chunks/NcActionButtonGroup-DCKhQnHH.mjs";
import NcActionCaption from "./Components/NcActionCaption.mjs";
import NcActionCheckbox from "./Components/NcActionCheckbox.mjs";
import { N as NcActionInput } from "./chunks/NcActionInput-9zrp0_WC.mjs";
import NcActionLink from "./Components/NcActionLink.mjs";
import NcActionRadio from "./Components/NcActionRadio.mjs";
import NcActionRouter from "./Components/NcActionRouter.mjs";
import { N as NcActions } from "./chunks/NcActions-VXT4YqSd.mjs";
import NcActionSeparator from "./Components/NcActionSeparator.mjs";
import NcActionText from "./Components/NcActionText.mjs";
import NcActionTextEditable from "./Components/NcActionTextEditable.mjs";
import { N as NcAppContent } from "./chunks/NcAppContent-B-VnA8x6.mjs";
import NcAppContentDetails from "./Components/NcAppContentDetails.mjs";
import NcAppContentList from "./Components/NcAppContentList.mjs";
import { N as NcAppNavigation } from "./chunks/NcAppNavigation-BoSCCzgq.mjs";
import { N as NcAppNavigationCaption } from "./chunks/NcAppNavigationCaption-D5IlWwqU.mjs";
import NcAppNavigationIconBullet from "./Components/NcAppNavigationIconBullet.mjs";
import { N as NcAppNavigationItem } from "./chunks/NcAppNavigationItem-BvTE5-IF.mjs";
import NcAppNavigationList from "./Components/NcAppNavigationList.mjs";
import NcAppNavigationNew from "./Components/NcAppNavigationNew.mjs";
import { N as NcAppNavigationNewItem } from "./chunks/NcAppNavigationNewItem-a_KNNkkf.mjs";
import { N as NcAppNavigationSettings } from "./chunks/NcAppNavigationSettings-ZYhJhZza.mjs";
import NcAppNavigationSpacer from "./Components/NcAppNavigationSpacer.mjs";
import { N as NcAppSettingsDialog } from "./chunks/NcAppSettingsDialog-B_JHYQei.mjs";
import NcAppSettingsSection from "./Components/NcAppSettingsSection.mjs";
import { N as NcAppSidebar } from "./chunks/NcAppSidebar-DfMS3rRN.mjs";
import NcAppSidebarTab from "./Components/NcAppSidebarTab.mjs";
import { N as NcAvatar } from "./chunks/NcAvatar-DrN_43xE.mjs";
import { u } from "./chunks/NcAvatar-DrN_43xE.mjs";
import { N as NcBreadcrumb } from "./chunks/NcBreadcrumb-BB7O3NvV.mjs";
import { N as NcBreadcrumbs } from "./chunks/NcBreadcrumbs-BRl8V6ie.mjs";
import NcButton from "./Components/NcButton.mjs";
import { N as NcCheckboxRadioSwitch } from "./chunks/NcCheckboxRadioSwitch-08IiPYnO.mjs";
import { N as NcColorPicker } from "./chunks/NcColorPicker-C5AAUZow.mjs";
import { N as NcContent } from "./chunks/NcContent-DlpAl0Ng.mjs";
import NcCounterBubble from "./Components/NcCounterBubble.mjs";
import { N as NcDashboardWidget } from "./chunks/NcDashboardWidget-Bgws_A-4.mjs";
import { N as NcDashboardWidgetItem } from "./chunks/NcDashboardWidgetItem-yOTSuJJW.mjs";
import { N as NcDateTime } from "./chunks/NcDateTime-DBvDI3ZP.mjs";
import { u as u2 } from "./chunks/NcDateTime-DBvDI3ZP.mjs";
import NcDateTimePicker from "./Components/NcDateTimePicker.mjs";
import NcDateTimePickerNative from "./Components/NcDateTimePickerNative.mjs";
import { N as NcDialog } from "./chunks/NcDialog-CDQmAtFa.mjs";
import { N as NcDialogButton } from "./chunks/NcDialogButton-JvyN3X6S.mjs";
import NcEllipsisedOption from "./Components/NcEllipsisedOption.mjs";
import { N as NcEmojiPicker } from "./chunks/NcEmojiPicker-CEeN-AZM.mjs";
import NcEmptyContent from "./Components/NcEmptyContent.mjs";
import NcGuestContent from "./Components/NcGuestContent.mjs";
import { N as NcHeaderMenu } from "./chunks/NcHeaderMenu-BEp6lzuy.mjs";
import { N as NcHighlight } from "./chunks/index-CsogA-K5.mjs";
import { N as NcIconSvgWrapper } from "./chunks/NcIconSvgWrapper-Ckqpz-vm.mjs";
import NcInputField from "./Components/NcInputField.mjs";
import { N as NcListItem } from "./chunks/NcListItem-PX9C1UU4.mjs";
import { N as NcListItemIcon } from "./chunks/NcListItemIcon-NtOXrncP.mjs";
import NcLoadingIcon from "./Components/NcLoadingIcon.mjs";
import NcModal from "./Components/NcModal.mjs";
import NcNoteCard from "./Components/NcNoteCard.mjs";
import { N as NcPasswordField } from "./chunks/NcPasswordField-XxjYVmM9.mjs";
import { N as NcPopover } from "./chunks/NcPopover-VxUr4c6P.mjs";
import { N as NcProgressBar } from "./chunks/NcProgressBar-CZtllSde.mjs";
import { N as NcRelatedResourcesPanel } from "./chunks/NcRelatedResourcesPanel-wFENPmmn.mjs";
import { N as NcMentionBubble } from "./chunks/index-CVcTbcD3.mjs";
import { r } from "./chunks/index-CVcTbcD3.mjs";
import { N as NcAutoCompleteResult, a as NcRichContenteditable } from "./chunks/NcRichContenteditable-BGW5Ut1z.mjs";
import { N as NcRichText } from "./chunks/NcRichText-D3knHFLh.mjs";
import { N, h, d, i, b, r as r2, c, a } from "./chunks/index-BwyQ2N-M.mjs";
import "@vueuse/core";
import "vue";
import "vue-router";
import { a as a2, g, b as b2, c as c2, d as d2, s } from "./chunks/referencePickerModal-CGhrhjCk.mjs";
import "unist-util-visit";
import "unist-builder";
import "@nextcloud/router";
import "@nextcloud/axios";
/* empty css                                                                            */
import { N as NcSelect } from "./chunks/NcSelect-BVltxWdw.mjs";
import { N as NcTextField } from "./chunks/NcTextField-C8iERu7z.mjs";
import "@nextcloud/event-bus";
import { N as NcSavingIndicatorIcon } from "./chunks/NcSavingIndicatorIcon-Bhy7wcoT.mjs";
import { N as NcSelectTags } from "./chunks/NcSelectTags-BA6aGEca.mjs";
import { N as NcSettingsInputText } from "./chunks/NcSettingsInputText-CXURkBMD.mjs";
import { N as NcSettingsSection } from "./chunks/NcSettingsSection-PZ3JkBWO.mjs";
import { N as NcSettingsSelectGroup } from "./chunks/NcSettingsSelectGroup-Z3yYfNTs.mjs";
import NcTextArea from "./Components/NcTextArea.mjs";
import { N as NcTimezonePicker } from "./chunks/NcTimezonePicker-BlnrXG8A.mjs";
import { N as NcUserBubble } from "./chunks/NcUserBubble-BiLpvdja.mjs";
import { N as NcUserStatusIcon } from "./chunks/NcUserStatusIcon-DLhfp6bb.mjs";
import NcVNodes from "./Components/NcVNodes.mjs";
import { isFullscreenState, useIsFullscreen } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT, MOBILE_SMALL_BREAKPOINT, isMobileState, useIsMobile, useIsSmallMobile } from "./Composables/useIsMobile.mjs";
import { isA11yActivation } from "./Functions/a11y.mjs";
import { E, a as a3, e, g as g2, s as s2 } from "./chunks/emoji-V6ytyzoR.mjs";
import { u as u3 } from "./chunks/usernameToColor-BkmF7_85.mjs";
import { directive } from "./Directives/Focus.mjs";
import { directive as directive$1 } from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as default2 } from "./Mixins/clickOutsideOptions.mjs";
import { default as default3 } from "./Mixins/isFullscreen.mjs";
import { default as default4 } from "./Mixins/isMobile.mjs";
import { VTooltip } from "floating-vue";
import { VTooltip as VTooltip2 } from "floating-vue";
const NcComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarTab,
  NcAutoCompleteResult,
  NcAvatar,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes
}, Symbol.toStringTag, { value: "Module" }));
const NcDirectives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: directive,
  Linkify: directive$1,
  Tooltip: VTooltip
}, Symbol.toStringTag, { value: "Module" }));
const NextcloudVuePlugin = {
  install(Vue) {
    Object.entries(NcComponents).forEach(([name, component]) => {
      Vue.component(component.name || name, component);
    });
    Object.entries(NcDirectives).forEach(([name, directive2]) => {
      Vue.directive(name, directive2);
    });
  }
};
export {
  E as EmojiSkinTone,
  directive as Focus,
  directive$1 as Linkify,
  MOBILE_BREAKPOINT,
  MOBILE_SMALL_BREAKPOINT,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarTab,
  NcAutoCompleteResult,
  NcAvatar,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  N as NcCustomPickerRenderResult,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes,
  NextcloudVuePlugin,
  VTooltip2 as Tooltip,
  a2 as anyLinkProviderId,
  default2 as clickOutsideOptions,
  a3 as emojiAddRecent,
  e as emojiSearch,
  g2 as getCurrentSkinTone,
  g as getLinkWithPicker,
  b2 as getProvider,
  c2 as getProviders,
  h as hasInteractiveView,
  isA11yActivation,
  d as isCustomPickerElementRegistered,
  default3 as isFullscreen,
  isFullscreenState,
  default4 as isMobile,
  isMobileState,
  i as isWidgetRegistered,
  b as registerCustomPickerElement,
  r2 as registerWidget,
  c as renderCustomPickerElement,
  a as renderWidget,
  r as richEditor,
  d2 as searchProvider,
  s2 as setCurrentSkinTone,
  s as sortProviders,
  u2 as useFormatDateTime,
  useIsFullscreen,
  useIsMobile,
  useIsSmallMobile,
  u as userStatus,
  u3 as usernameToColor
};
